var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "template8wrapper" }, [
    _c("h2", [_vm._v(_vm._s(_vm.question.title))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.question.subTitle))]),
    _vm._v(" "),
    _c("div", { staticClass: "answersWrapper" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selected,
              expression: "selected",
            },
          ],
          ref: "select2",
          staticClass: "select2",
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selected = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.selectAnswer,
            ],
          },
        },
        [
          _c("option", { attrs: { disabled: "", value: "" } }, [
            _vm._v(
              "\n                " +
                _vm._s(this.quizData.translations.templateq6select) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _vm._l(this.selectAnswers, function (answer) {
            return _c(
              "option",
              {
                key: answer.id,
                attrs: { title: answer.text },
                domProps: { value: answer.id },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(answer.title) +
                    "\n                " +
                    _vm._s(
                      answer.subTitle && answer.subTitle.trim() !== ""
                        ? "-"
                        : ""
                    ) +
                    "\n                " +
                    _vm._s(answer.subTitle) +
                    "\n            "
                ),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      this.answers.length > 3
        ? _c("div", { staticClass: "selectAnswers" }, [
            _c(
              "a",
              {
                staticClass: "quizButton",
                attrs: { id: "quizButton", href: "", title: _vm.lastItem.text },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.checkAnswer(_vm.lastItem.id)
                    _vm.submitQuestion()
                  },
                  mouseenter: function ($event) {
                    return _vm.mouseOver(_vm.lastItem.id)
                  },
                  mouseleave: function ($event) {
                    return _vm.mouseOut(_vm.lastItem.id, $event)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.lastItem.title))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "quizButton",
                attrs: {
                  id: "quizButton",
                  href: "",
                  title: _vm.secondLastItem.text,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.checkAnswer(_vm.secondLastItem.id)
                    _vm.submitQuestion()
                  },
                  mouseenter: function ($event) {
                    return _vm.mouseOver(_vm.secondLastItem.id)
                  },
                  mouseleave: function ($event) {
                    return _vm.mouseOut(_vm.secondLastItem.id, $event)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.secondLastItem.title))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.lastItem.hovered,
              expression: "lastItem.hovered",
            },
          ],
          staticClass: "subtitleLastItem",
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.lastItem.subTitle) + "\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.secondLastItem.hovered,
              expression: "secondLastItem.hovered",
            },
          ],
          staticClass: "subtitleSecondLastItem",
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.secondLastItem.subTitle) +
              "\n        "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }